<template>
    <!-- 实验室信息管理系统 -->
    <div id="tab4" class="img-show page-width main-content">
        <!-- 产品介绍 -->
        <div>
            <div class="sub-title">
                <p>实验室信息管理系统</p>
            </div>
            <img
                src="../../../../../assets/img/softProduct/lims/系统介绍.jpg"
                alt="系统介绍"
                class="app-img"
            />
        </div>
        <!-- 功能架构 -->
        <div>
            <div class="sub-title">
                <p>功能架构</p>
            </div>
            <img
                src="../../../../../assets/img/softProduct/lims/功能架构.png"
                alt="功能架构"
                class="app-img"
            />
        </div>
        <!-- 行业现状 -->
        <div>
            <div class="sub-title">
                <p>行业现状</p>
            </div>
            <img
                src="../../../../../assets/img/softProduct/lims/行业现状.jpg"
                alt="行业现状"
                class="app-img"
            />
        </div>
        <!-- 系统特点 -->
        <div>
            <div class="sub-title">
                <p>系统特点</p>
            </div>
            <img
                src="../../../../../assets/img/softProduct/lims/系统特点.jpg"
                alt="系统特点"
                class="app-img"
            />
        </div>
        <!-- 检测业务流程 -->
        <div>
            <div class="sub-title">
                <p>检测业务流程</p>
            </div>
            <img
                src="../../../../../assets/img/softProduct/lims/检测业务流程.png"
                alt="检测业务流程"
                class="app-img"
            />
        </div>
        <!-- 系统版本 -->
        <div>
            <div class="sub-title">
                <p>系统版本</p>
            </div>
            <img
                src="../../../../../assets/img/softProduct/lims/系统版本.jpg"
                alt="系统版本"
                class="app-img"
            />
        </div>
        <!-- 系统功能 -->
        <div>
            <div class="sub-title">
                <p>系统功能</p>
            </div>
            <img
                src="../../../../../assets/img/softProduct/lims/系统及配置.jpg"
                alt="系统及配置"
                class="app-img"
            />
            <img
                src="../../../../../assets/img/softProduct/lims/实验室资源管理.jpg"
                alt="实验室资源管理"
                class="app-img"
            />
            <img
                src="../../../../../assets/img/softProduct/lims/客户关系管理.jpg"
                alt="客户关系管理"
                class="app-img"
            />
            <img
                src="../../../../../assets/img/softProduct/lims/检测项目管理.jpg"
                alt="检测项目管理"
                class="app-img"
            />
            <img
                src="../../../../../assets/img/softProduct/lims/检测流程.jpg"
                alt="检测流程"
                class="app-img"
            />
            <img
                src="../../../../../assets/img/softProduct/lims/评审管理.jpg"
                alt="评审管理"
                class="app-img"
            />
            <img
                src="../../../../../assets/img/softProduct/lims/知识库.jpg"
                alt="知识库"
                class="app-img"
            />
            <img
                src="../../../../../assets/img/softProduct/lims/统计分析.jpg"
                alt="统计分析"
                class="app-img"
            />
             <div class="img-bottom"></div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
@import './softProduct.less';
.app-img{
    margin:20px 0;
}
</style>
